import React from 'react';
import PaymentHistoryContainer from '@src/containers/PaymentHistory';

const PaymentHistory = () => <PaymentHistoryContainer />;

export default PaymentHistory;
